import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import { MarqueeStrip, GenreChipsRow } from '../components/Marquee';
import About from '../components/About';
import Setup from '../components/Setup';
import Mixes from '../components/Mixes';
import ViralReel from '../components/ViralReel';
import Testimonials from '../components/Testimonials';
import Services from '../components/Services';
import FAQ from '../components/FAQ';
import CTA, { Footer } from '../components/CTA';

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0a0612] text-white overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <MarqueeStrip />
        <GenreChipsRow />
        <About />
        <Setup />
        <Mixes />
        <ViralReel />
        <Testimonials />
        <Services />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
